import React from 'react';

import { AppDispatcher } from 'types/appEvent';

export const AppDispatcherContext = React.createContext<AppDispatcher>(
  () => {}
);
